import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOptAlt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconOptAlt"><Path fillRule="evenodd" clipRule="evenodd" d="M15.5572 4H21V5.5H16.4428L8.44278 20H3V18.5H7.55722L15.5572 4ZM15 18.5H21V20H15V18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOptAlt;
